import { StarHalfIcon, StarOffIcon, StarOnIcon } from '@/components/icon'

interface Props {
  score: number
  className?: string
}
export const Stars: React.FC<Props> = ({
  score,
  className = 'w-[26px] h-[26px]',
}) => {
  const renderStar = (score: number) => {
    let stars = []
    // 黄色い星の数
    const starOnCount = Math.floor(score)
    // 半分の星を表示するか？
    const halfStarCount = score - starOnCount >= 0.5 ? 1 : 0
    // 灰色の星の数
    const starOffCount = 5 - starOnCount - halfStarCount

    stars = Array(starOnCount)
      .fill(0)
      .map((_, i) => (
        <StarOnIcon key={`star-full-${i}`} className={className} />
      ))
    // 小数点がある場合は半分の星を追加する
    if (halfStarCount) {
      stars.push(<StarHalfIcon key="star-half" className={className} />)
    }
    // 評点が埋まりきっていない場合は灰色の星で埋める
    Array(starOffCount)
      .fill(0)
      .forEach((_, i) =>
        stars.push(<StarOffIcon key={`star-off-${i}`} className={className} />)
      )
    return stars
  }
  return <>{renderStar(score)}</>
}
